const magicScroll = {
  init: function (box, element, line) {
    if (!document.getElementById(box)) return;

    let leftPos, newWidth;
    const navList = document.getElementById(box).querySelector(line);
    const magicLine = document.createElement("li");
    magicLine.classList = "magic-line";
    // Get a reference to the first child
    const theFirstChild = navList.firstChild;
    navList.insertBefore(magicLine, theFirstChild);
    navList.classList.add("has-magic-line");

    Array.from(document.querySelectorAll(element)).forEach((tabLink) => {
      if (tabLink.parentElement.classList.contains("sk-btn")) return;

      tabLink.addEventListener("click", function () {
        this.parentNode.classList.add("active");
        Array.from(this.parentNode.parentNode.children).forEach((sibling) => {
          if (sibling !== this.parentNode) {
            sibling.classList.remove("active");
          }
        });

        magicLine.dataset.origLeft = this.offsetLeft + 1;
        magicLine.dataset.origWidth = this.parentNode.offsetWidth;
      });

      if (tabLink.parentNode.classList.contains("active")) {
        leftPos = tabLink.offsetLeft + 1;
        newWidth = tabLink.parentNode.offsetWidth;
        magicLine.style.left = `${leftPos}px`;
        magicLine.style.width = `${newWidth}px`;
        magicLine.dataset.origLeft = leftPos;
        magicLine.dataset.origWidth = newWidth;
      }
    });

    Array.from(document.querySelectorAll(element)).forEach((tabLink) => {
      if (tabLink.parentElement.classList.contains("sk-btn")) return;

      tabLink.addEventListener("mouseenter", function () {
        leftPos = this.offsetLeft + 1;
        newWidth = this.parentNode.offsetWidth;
        magicLine.style.left = `${leftPos}px`;
        magicLine.style.width = `${newWidth}px`;
      });

      tabLink.addEventListener("mouseleave", function () {
        magicLine.style.left = `${magicLine.dataset.origLeft}px`;
        magicLine.style.width = `${magicLine.dataset.origWidth}px`;
      });
    });
  },
};

export default magicScroll;
